import { CopyButton } from '@xver/components/Atoms';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';
import { BaremetalInstance } from '@xver/@types/instance';
import { imageOsLabel, ResolvedBaremetalImage } from '@xver/utils/baremetal';
import { useTranslation } from 'react-i18next';
import InfoRow from './InfoRow';

interface SystemInfoCardProps {
    baremetal: BaremetalInstance;
    image: ResolvedBaremetalImage;
}

export default function SystemInfoCard({ baremetal, image }: SystemInfoCardProps) {
    const { t } = useTranslation('bareMetal');
    const { specs } = baremetal;
    const ip = baremetal.network.ip_address;

    return (
        <DialogBox label={t('detail.system.title')} classNames="p-4">
            <dl className="w-full grid grid-cols-[auto_1fr] items-center gap-x-6 gap-y-4 m-0">
                <InfoRow
                    label={t('detail.system.hostname')}
                    value={
                        <span className="flex items-center justify-between gap-3">
                            <span className="min-w-0 break-all">{baremetal.hostname}</span>
                            <CopyButton
                                value={baremetal.hostname}
                                ariaLabel={t('detail.system.copyHostname')}
                            />
                        </span>
                    }
                />
                <InfoRow
                    label={t('detail.system.ipAddress')}
                    value={
                        ip && (
                            <span className="flex items-center justify-between gap-3">
                                <span className="min-w-0 font-mono text-sm break-all">{ip}</span>
                                <CopyButton
                                    value={ip}
                                    ariaLabel={t('detail.system.copyIpAddress')}
                                />
                            </span>
                        )
                    }
                />
                <InfoRow label={t('detail.system.os')} value={imageOsLabel(image)} />
                <InfoRow label={t('detail.system.cpu')} value={specs.cpu} />
                <InfoRow label={t('detail.system.cores')} value={specs.core} />
                <InfoRow label={t('detail.system.sockets')} value={specs.socket} />
                <InfoRow label={t('detail.system.memory')} value={specs.memory} />
                <InfoRow label={t('detail.system.storage')} value={specs.storage} />
                <InfoRow label={t('detail.system.network')} value={specs.network} />
            </dl>
        </DialogBox>
    );
}
